import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { AuditMessage } from '@app/entities/models/audit/audit.model';

export interface AuditRepository {
  flush(auditMessages: AuditMessage[]): Observable<object>;
}

export const AUDIT_REPOSITORY = new InjectionToken<AuditRepository>('AUDIT_REPOSITORY');
